import { render, staticRenderFns } from "./ProductContentPage.vue?vue&type=template&id=2e35685e&scoped=true&"
import script from "./ProductContentPage.vue?vue&type=script&lang=js&"
export * from "./ProductContentPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentPage.vue?vue&type=style&index=0&id=2e35685e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35685e",
  null
  
)

export default component.exports